window.Page = {

    // Let's launch this thing
    liftoff : () => {
        Site.filterProjectsOnClick()
    },

};

Page.liftoff()